import React, { useEffect, useState } from "react";
import { View } from "react-native";
import { EStyleSheet, useDynamicStyles } from "react-native-extended-stylesheet-typescript";
import { Option } from "react-dropdown";
import { FreeplayEvent } from "@freeplay/shared-code";
import { Select, SelectValue } from "../formElements/Select";

export type LeaderboardDropdownType = { label: string; value: FreeplayEvent };

type Props = {
    dropdownData?: Option[];
    value: Option;
    eventSelected: (arg: Option) => void;
};

export const LeaderboardDropdown: React.FC<Props> = ({ dropdownData, eventSelected, value }) => {
    const [selectValue, setSelectValue] = useState<SelectValue<string>>({
        data: value.value,
        label: value.label as string,
    });
    const styles = useDynamicStyles(generateStyles);

    useEffect(() => {
        setSelectValue({
            data: value.value,
            label: value.label as string,
        });
    }, [value]);

    if (!dropdownData) {
        return <></>;
    }

    const selectData: SelectValue<string>[] = [];

    for (const dropdownOption of dropdownData) {
        selectData.push({ data: dropdownOption.value, label: dropdownOption.label as string });
    }

    const handleSelection = (selectionIndex: number) => {
        eventSelected(dropdownData[selectionIndex]);
        setSelectValue({
            data: dropdownData[selectionIndex].value,
            label: dropdownData[selectionIndex].label as string,
        });
    };

    return (
        <View style={styles.container}>
            <Select handleSelection={handleSelection} disabled={false} options={selectData} value={selectValue} />
        </View>
    );
};

const generateStyles = () => {
    return EStyleSheet.create({
        container: {
            alignSelf: "stretch",
            paddingHorizontal: 10,
            zIndex: 1,
        },
        text: {
            paddingLeft: "40%",
            color: "white",
            fontSize: 20,
        },
        right: {
            paddingLeft: "40%",
        },
    });
};
